module.exports = __webpack_public_path__ + "static/media/Knight-horse012_4c.5ccc86d8.svg";